import { CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { AgreeToThePolicies, ChooseFile, Description, EmailAddress, EmailPlaceholder, FirstName, FirstNamePlaceholder,PasswordBrowserDefault, SelectYourPaymentMethod, State, StateChoose, SubmitButton, SureInformation,} from "../../../../Constant";
import { BROWSER_DEFAULT_RADIO, BROWSER_DEFAULT_LIST } from "../../../../Data/FormControl/FormValidation";
import { Btn, H6 } from "../../../../AbstractElements";

export const BrowserDefaultsCardBody = () => {
  return (
    <CardBody className="custom-input">
      <Form className="g-3" onSubmit={(e) => e.preventDefault()}>
        <Row>
        <Col sm="12">
          <Label htmlFor="first-name">{FirstName}</Label>
          <Input type="text" placeholder={FirstNamePlaceholder} required />
        </Col>
        <Col sm="12">
          <Label>{EmailAddress}</Label>
          <Input type="email" placeholder={EmailPlaceholder} required />
        </Col>
        <Col sm="12">
          <Label className="col-sm-12" htmlFor="inputPassword2">
            {PasswordBrowserDefault}
          </Label>
          <Input id="inputPassword2" type="password" autoComplete="" required />
        </Col>
        <Col sm="12">
          <Label>{State}</Label>
          <Input type="select" className="form-select" id="validationDefault04" required>
            <option>{StateChoose}</option>
            {BROWSER_DEFAULT_LIST.map((item, index) => (<option value={item} key={index}>{item}</option>))}
          </Input>
        </Col>
        <Col sm="12">
          <Label>{ChooseFile}</Label>
          <Input type="file" required />
        </Col>
        <Col sm="12">
          <div className="card-wrapper border rounded-3 checkbox-checked">
            <H6 className="sub-title">{SelectYourPaymentMethod}</H6>
            <div className="radio-form">
              {BROWSER_DEFAULT_RADIO.map(({ id, defaultChecked, text }, index) => (
                <FormGroup check key={index}>
                  <Input type="radio" name="flexRadioDefault" id={`flexRadioDefault${id}`} required defaultChecked={defaultChecked} />
                  <Label className="form-check-label" htmlFor={`flexRadioDefault${id}`}>{text}</Label>
                </FormGroup>
              ))}
            </div>
          </div>
        </Col>
        <Col sm="12">
          <Label>{Description}</Label>
          <Input type="textarea" rows={3} />
        </Col>
        <Col sm="12" className="checkbox-checked">
          <Input className="form-check-input" id="flexCheckDefault" type="checkbox" />
          <Label className="form-check-label ms-2" htmlFor="flexCheckDefault" check>{AgreeToThePolicies}</Label>
        </Col>
        <Col sm="12">
          <FormGroup className="form-switch" check>
            <Input className="form-check-input" id="flexSwitchCheckDefault" type="checkbox" role="switch" required />
            <Label className="form-check-label" htmlFor="flexSwitchCheckDefault" check>{SureInformation}</Label>
          </FormGroup>
        </Col>
        <Col sm="12">
          <Btn color="primary">{SubmitButton}</Btn>
        </Col>
        </Row>
      </Form>
    </CardBody>
  );
};
